"use client";
// 파트너 로고 glass 푸터 (easy-reference .main-footer 이식)
// alt 는 기관명으로 — 전부 "Partner Logo" 였을 땐 스크린리더에서 7개가 구분이 안 됐다. 로케일별 기관명.
import { useTranslations } from "next-intl";

const PARTNERS: { file: string; key: string }[] = [
  { file: "1.logo_kukkiwon.png", key: "kukkiwon" },
  { file: "2.logo_WT.png", key: "wt" },
  { file: "3.logo_KTA.png", key: "kta" },
  { file: "4.logo_ATU.png", key: "atu" },
  // 08-11: 과학기술정보통신부 → 특허청으로 교체하고 중소벤처기업부를 더했다(브로슈어 로고판과 맞춤).
  //  🛑 옛 파일 5.logo_ICT.png 는 지우지 않고 남겨 뒀다.
  { file: "5.logo_KIPO.png", key: "kipo" },
  { file: "6.logo_kspo.png", key: "kspo" },
  { file: "7.logo_data.png", key: "dataCert" },
  { file: "8.logo_MSS.png", key: "mss" },
];

export function PartnerFooter() {
  const t = useTranslations("components.partner");
  return (
    <footer className="partner-footer glass-bar animate-wave">
      {PARTNERS.map((p) => (
        <img
          key={p.file}
          src={`/brand/${p.file}`}
          alt={t(p.key)}
          // 국기원만 살짝 크게 — 크기·후광은 globals.css `.partner-footer img.lead` 에 있다
          // (인라인이면 모바일 축소 미디어쿼리를 이긴다).
          className={p.file.startsWith("1.") ? "lead" : undefined}
        />
      ))}
    </footer>
  );
}
